<template>
  <block
    component-name="block-grid-ol"
    body-class="flex flex-col items-stretch gap-4xl"
  >
    <wrapper-split-text v-if="$attrs.data.body.title" reveal="words">
      <div v-html="$attrs.data.body.title" class="text-heading-3"></div>
    </wrapper-split-text>

    <ol class="grid w-full grid-cols-12 list-none gap-x-ui gap-y-4xl">
      <li
        v-for="(item, index) in $attrs.data.body.items"
        class="flex flex-col items-stretch w-full col-span-full phablet:col-span-6 tablet:col-span-4 desktop:col-span-3 gap-lg"
      >
        <divider />
        <wrapper-reveal reveal="fade-from-right">
          <div
            v-html="`${index + 1 < 10 ? '0' : ''}${index + 1}.`"
            class="text-body-big tabular-nums"
          ></div>
        </wrapper-reveal>

        <wrapper-reveal reveal="fade-from-bottom">
          <div v-html="item.text" class="text-body-big"></div>
        </wrapper-reveal>
      </li>
    </ol>
  </block>
</template>
